import React, { useState } from 'react';
import { Container, Nav, Navbar , NavDropdown, Badge } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import '../scss/navbar.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCartShopping, faPowerOff } from '@fortawesome/free-solid-svg-icons';
 
// import NavLogo from './images/kma-logo-white.png';

const TopNavbar = ({ login, userName, selectedList }) => {

    const goHome = (e) => {
        e.preventDefault();
        window.location.replace("https://www.marathonkuching.com/");
    }

  return (
    <>
        <Navbar collapseOnSelect expand="lg" variant="dark">
            <Container>
                <LinkContainer to="/Home" onClick={goHome}>
                    <Navbar.Brand>
                        <img id="navbar-logo" src={process.env.PUBLIC_URL + '/images/kma-logo-white.png'} />
                    </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        {/* <LinkContainer to="/Home" onClick={goHome}>
                            <Nav.Link>Home</Nav.Link>
                        </LinkContainer> */}
                        {/* <LinkContainer to="/RegisterMember">
                            <Nav.Link>Sign Up</Nav.Link>
                        </LinkContainer> */}
                        <LinkContainer to="/Register">
                            <Nav.Link>Registration</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/Shop">
                            <Nav.Link>Shop</Nav.Link>
                        </LinkContainer>
                        {/* <LinkContainer to="/Payment">
                            <Nav.Link>Payment</Nav.Link>
                        </LinkContainer> */}
                    </Nav>
                    <Nav>
                        {login ? (
                            <NavDropdown
                                title={
                                    <span style={{color:"white"}} className="my-auto">{userName}</span>
                                } 
                                className="navbar-personal"
                                align="end"
                            >
                                <LinkContainer to="/Profile">
                                    <NavDropdown.Item className="d-flex align-items-center">
                                        <div className="icon d-flex align-items-center justify-content-center mr-3">
                                            <span><FontAwesomeIcon icon={faUser} /></span>
                                        </div>
                                        <span className="dropdown-item-text">
                                            Profile
                                        </span>
                                    </NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to="/Cart">
                                    <NavDropdown.Item className="d-flex align-items-center">
                                        <div className="icon d-flex align-items-center justify-content-center mr-3">
                                            <span><FontAwesomeIcon icon={faCartShopping} /></span>
                                        </div>
                                        <span className="dropdown-item-text">
                                            Cart {selectedList.length>0 && (<Badge bg="danger">{selectedList.length}</Badge>)} 
                                        </span>
                                    </NavDropdown.Item>
                                </LinkContainer>
                                {/* <NavDropdown.Divider /> */}
                                <LinkContainer to="/Logout">
                                    <NavDropdown.Item className="d-flex align-items-center">
                                        <div className="icon d-flex align-items-center justify-content-center mr-3">
                                            <span><FontAwesomeIcon icon={faPowerOff } /></span>
                                        </div>
                                        <span className="dropdown-item-text">
                                            Logout
                                        </span>
                                    </NavDropdown.Item>
                                </LinkContainer>
                            </NavDropdown>
                        ) : (
                            <LinkContainer to="/Login">
                                <Nav.Link>Log In</Nav.Link>
                            </LinkContainer>
                        )}
                        
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    </>
  );
}

export default TopNavbar;